import { format, isValid, parseISO } from "date-fns";

const toDate = (dateVal: any): Date | null => {
  if (!dateVal) return null;
  if (dateVal instanceof Date) return isValid(dateVal) ? dateVal : null;
  if (typeof dateVal === "number") {
    const d = new Date(dateVal);
    return isValid(d) ? d : null;
  }
  const asString = String(dateVal).trim();
  if (!asString) return null;
  if (/^\d{4}$/.test(asString)) {
    const yearOnly = new Date(Number(asString), 0, 1);
    return isValid(yearOnly) ? yearOnly : null;
  }
  const parsedIso = parseISO(asString);
  if (isValid(parsedIso)) return parsedIso;
  const parsed = new Date(asString);
  return isValid(parsed) ? parsed : null;
};

export const formatDate = (dateVal: any) => {
  const d = toDate(dateVal);
  return d ? format(d, "dd-MMM-yyyy") : "";
};

export const formatTime = (dateVal: any) => {
  const d = toDate(dateVal);
  return d ? format(d, "h:mmaaa").toLowerCase() : "";
};

export const formatDateTime = (dateVal: any) => {
  const datePart = formatDate(dateVal);
  const timePart = formatTime(dateVal);
  if (!datePart) return "";
  return timePart ? `${datePart} ${timePart}` : datePart;
};